import React from 'react';
import T from 'prop-types';
import { Modal, Divider } from 'antd';
import { CreditCardOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import get from 'lodash.get';

import useBillingCycle from '../../hooks/useBillingCycle';
import {
  BILLING_CYCLE_MONTHLY,
  PRODUCT_PROFESSIONAL_PRICES,
  PRODUCT_PROFESSIONAL_YEARLY,
  PRODUCT_PROFESSIONAL_MONTHLY,
} from '../../constants/payment';
import * as fmt from '../../utils/formatters';

import ErrorAlert from '../errorAlert';
import BillingCycleSwitch from '../billingCycleSwitch';

import PlanDetails from './subcomponents/planDetails';

import { Note, MoreInfo } from './style';

export const getPriceAndPlanId = (billingCycle) => {
  const p = get(PRODUCT_PROFESSIONAL_PRICES, billingCycle);

  if (billingCycle === BILLING_CYCLE_MONTHLY) {
    return {
      price: `${fmt.currencyUSD(p)}`,
      planId: PRODUCT_PROFESSIONAL_MONTHLY,
    };
  }

  return {
    price: `${fmt.currencyUSD(p * 12)}`,
    planId: PRODUCT_PROFESSIONAL_YEARLY,
  };
};

const UpgradeToProfessionalModal = ({
  updateSubscription,
  isLoading,
  isVisible,
  hideUpdateSubscriptionModal,
  error,
  errorMessage,
  isUserAdvanced,
}) => {
  const [billingCycle, handleBillingChange] = useBillingCycle(BILLING_CYCLE_MONTHLY);
  const { price, planId } = getPriceAndPlanId(billingCycle);

  if (!isUserAdvanced) {
    return null;
  }

  return (
    <>
      <Modal
        bordered={false}
        destroyOnClose
        maskClosable
        okButtonProps={{ loading: isLoading, type: 'primary', icon: <CreditCardOutlined /> }}
        okText={`Pay max. ${price}`}
        onCancel={hideUpdateSubscriptionModal}
        onOk={() => updateSubscription(planId)}
        title="Upgrade to the Professional plan"
        visible={isVisible}
        zIndex={1010}
      >
        <ErrorAlert message={errorMessage} visible={error} />

        <BillingCycleSwitch defaultChecked={false} onChange={handleBillingChange} />
        <Divider />

        <PlanDetails billingCycle={billingCycle} />

        <Divider />

        <Note>
          When upgrading your plan, the actual amount debited will be less than the new plan's price. Appropriate
          pricing adjustments will be applied based on how much of the current plan you have used.
        </Note>

        <MoreInfo>
          Compare all plan features <Link to="/pricing">here</Link>
        </MoreInfo>
      </Modal>
    </>
  );
};

UpgradeToProfessionalModal.propTypes = {
  updateSubscription: T.func.isRequired,
  hideUpdateSubscriptionModal: T.func.isRequired,

  isLoading: T.bool.isRequired,
  isVisible: T.bool.isRequired,
  isUserAdvanced: T.bool.isRequired,
  error: T.bool.isRequired,
  errorMessage: T.string.isRequired,
};

export default UpgradeToProfessionalModal;
